module.exports = __webpack_public_path__ + "img/RS822RP+RS822+.59cd11ee.png";